var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadArrowCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25426",
    "data-name": "Group 25426",
    transform: "translate(-1364 -11304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25425",
    "data-name": "Group 25425",
    transform: "translate(1364 11304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24900",
    "data-name": "Group 24900",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1564",
    "data-name": "Ellipse 1564",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#396"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "direct-download",
    transform: "translate(1371 11310.854)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7369",
    "data-name": "Path 7369",
    d: "M8.463,7.747a.307.307,0,0,1-.222-.1L6.085,5.394a.308.308,0,0,1,.222-.521H7.436V2.513A.514.514,0,0,1,7.95,2H8.976a.514.514,0,0,1,.513.513v2.36h1.129a.308.308,0,0,1,.222.521L8.685,7.652A.307.307,0,0,1,8.463,7.747Z",
    transform: "translate(-3.537 -2)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7370",
    "data-name": "Path 7370",
    d: "M9.134,19.642H.718A.719.719,0,0,1,0,18.924v-.205A.719.719,0,0,1,.718,18H9.134a.719.719,0,0,1,.718.718v.205A.719.719,0,0,1,9.134,19.642Z",
    transform: "translate(0 -11.432)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArrowCircle);
export default __webpack_public_path__ + "static/media/download-arrow_circle.4d5abbfdfc62532ef063e4643bb0ab34.svg";
export { ForwardRef as ReactComponent };